import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  src: string;
  ch: React.ReactNode;
};

const OgpImage: React.FC<Props> = ({ src, ch }) => {
  const hasImage = Boolean(src && src.trim() !== '');

  return (
    <Container className="OgpImage">
      <BgImage $hasImage={hasImage} $imageUrl={src}>
        <Tip>{ch}</Tip>
      </BgImage>
    </Container>
  );
};

export default OgpImage;

const Container = styled.div`
  overflow: hidden;
  width: inherit;
  height: var(--talkn-image-height, 220px);
  border-top: 1px solid var(--talkn-border-color, #eee);
  border-bottom: 1px solid var(--talkn-border-color, #eee);
`;

type BgImagePropsType = {
  $hasImage: boolean;
  $imageUrl: string;
};

const BgImage = styled.div<BgImagePropsType>`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: inherit;
  height: inherit;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: var(--talkn-image-bg, #eee);
  ${(props) =>
    props.$hasImage
      ? css`
          background-image: url('${props.$imageUrl}');
        `
      : css`
          background-image: none;
        `}
`;

const Tip = styled.span`
  overflow: hidden;
  display: var(--talkn-tip-display, -webkit-box);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  padding: 6px 8px 8px 24px;
  margin: 16px 0 16px 16px;
  background: var(--talkn-tip-bg, rgba(0, 0, 0, 0.4));
  color: var(--talkn-tip-color, #fff);
  border-radius: 30px 0 0 30px;
  line-height: 28px;
  text-align: right;
  word-break: break-word;
`;
